import React from "react";
import { useRefinementList, useInstantSearch } from "react-instantsearch";

const LABELS = {
  online: "Online",
  surPlace: "Sur place",
};

const TRACK_W = 44;

export default function AccessToggle() {
  const { items, refine } = useRefinementList({ attribute: "access", limit: 10 });
  const { refresh } = useInstantSearch();

  const onlineItem = items.find((i) => i.label === "Tout public");
  const mvItem = items.find((i) => i.label === "MV");

  const onlineOn = onlineItem?.isRefined || false;
  const mvOn = mvItem?.isRefined || false;

  let state = "none";
  if (onlineOn && !mvOn) state = "online";
  if (!onlineOn && mvOn) state = "surPlace";

  const apply = (newState) => {
    // Ne retoucher que ce qui doit changer (évite double refine)
    if (newState === "online") {
      if (mvOn) refine("MV");
      if (!onlineOn) refine("Tout public");
    } else if (newState === "surPlace") {
      if (onlineOn) refine("Tout public");
      if (!mvOn) refine("MV");
    } else {
      // neutre
      if (onlineOn) refine("Tout public");
      if (mvOn) refine("MV");
    }
    refresh();
  };

  const handleTrackClick = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const third = TRACK_W / 3;
    if (x < third) apply("online");
    else if (x > third * 2) apply("surPlace");
    else apply("none");
  };

  const trackBg =
    state === "online" ? "rgb(46, 125, 50)" : state === "surPlace" ? "#1976d2" : "#ccc";

  const knobX =
    state === "online" ? "2px" : state === "surPlace" ? "26px" : "14px";

  return (
    <div className="sui-facet" style={{ marginBottom: "1rem" }}>
      <legend className="sui-facet__title">Accès</legend>
      <div
        style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: "6px" }}
      >
        <span
          style={{
            fontSize: "0.8rem",
            fontWeight: state === "online" ? 700 : 400,
            color: state === "online" ? "rgb(46, 125, 50)" : "#666",
            cursor: "pointer",
            userSelect: "none",
          }}
          onClick={() => apply("online")}
        >
          {LABELS.online}
        </span>

        <div
          onClick={handleTrackClick}
          title={
            state === "online"
              ? "Online (Tout public)"
              : state === "surPlace"
              ? "Sur place (MV)"
              : "Neutre — clic gauche=Online, droite=Sur place"
          }
          style={{
            width: TRACK_W,
            height: 20,
            borderRadius: 10,
            background: trackBg,
            cursor: "pointer",
            position: "relative",
            flexShrink: 0,
            transition: "background 0.2s",
            userSelect: "none",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: 2,
              left: knobX,
              width: 16,
              height: 16,
              borderRadius: "50%",
              background: "#fff",
              boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
              transition: "left 0.2s ease",
            }}
          />
        </div>

        <span
          style={{
            fontSize: "0.8rem",
            fontWeight: state === "surPlace" ? 700 : 400,
            color: state === "surPlace" ? "#1976d2" : "#666",
            cursor: "pointer",
            userSelect: "none",
          }}
          onClick={() => apply("surPlace")}
        >
          {LABELS.surPlace}
        </span>
      </div>
    </div>
  );
}
